import React from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./customModal.scss";

export default function CustomModal({ isOpened, item, ...props }) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered={true}
      animation={true}
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3 style={customStyles.titleStyle}>{item?.title}</h3>
          <div style={customStyles.roleContainer}>
            <span style={customStyles.roleLabel}>Role:</span>
            <span style={customStyles.roleStyle}>{item.role}</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={customStyles.stackContainer}>
          <span style={customStyles.roleLabel}>Tech Stack:</span>
          {item?.techStack?.map((element) => (
            <div style={customStyles.techStackItem}>{element}</div>
          ))}
        </div>
        <span style={{ whiteSpace: "pre-line" }}>{item?.longDesc}</span>
        <br />
        {item?.playStore && (
          <a href={item.playStore} target="_blank" rel="noreferrer">
            <img
              src="assets/playStore.png"
              style={customStyles.iconStyle}
              alt=""
            />
          </a>
        )}
        {item?.appStore && (
          <a href={item.appStore} target="_blank" rel="noreferrer">
            <img
              src="assets/appStore.png"
              style={customStyles.iconStyle}
              alt=""
            />
          </a>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

const customStyles = {
  titleStyle: {
    fontSize: 22,
    fontWeight: "600",
  },
  roleStyle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#325AAa",
  },
  roleLabel: {
    paddingTop: "0px",
    fontSize: 14,
    fontWeight: "600",
    paddingRight: "5px",
    color: "#535353",
  },
  roleContainer: {
    display: "flex",
    alignItems: "center",
  },
  stackContainer: {
    display: "flex",
    paddingTop: "0px",
    paddingBottom: "15px",
    alignItems: "center",
  },
  techStackItem: {
    backgroundColor: "#325AAa",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "8px",
    paddingRight: "8px",
    border: "1px solid #DCDCDC",
    borderRadius: "4px",
    marginRight: "10px",
    color: "#FFF",
  },
  iconStyle: {
    width: "50px",
    height: "50px",
    marginRight: "15px",
    marginTop: "10px",
    padding: "5px",
    border: "1px solid #325AAa",
    borderRadius: "5px",
  },
};
